// Contrail V3.9.0 — open a Support view: see one client company's live positions, history and reports for 1, 4 or 8 hours.
// Only Skyward admins a Super Admin has allowed. Logged in Activity and sent to the admins' Notifications.
import { FormEvent, useState } from "react";
import { adminApi, type Org } from "../../lib/admin";
import { Drawer, Field, Notice } from "./ui";

export default function SupportDialog({ orgs, defaultOrg, onClose }: { orgs: Org[]; defaultOrg?: string; onClose: () => void }) {
  const clients = orgs.filter((o) => o.type === "client" && o.status !== "closed");
  const [org, setOrg] = useState(defaultOrg ?? clients[0]?.id ?? "");
  const [hours, setHours] = useState(1);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  async function start(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setErr(null);
    try { await adminApi("POST", "support", { org_id: org, hours, reason: reason.trim() }); window.location.href = "/map"; }
    catch (x: any) { setErr(x.message); setBusy(false); }
  }
  return (
    <Drawer title="Open Support view" onClose={onClose}
      footer={<><button className="btn-ghost" onClick={onClose}>Cancel</button><button className="btn-primary" form="support-form" disabled={busy || !org}>{busy ? "Opening…" : "Open Support view"}</button></>}>
      <form id="support-form" className="aform" onSubmit={start}>
        <p className="wide sub">See one client company's live map, history, events, zones, fleet register and reports for a limited time, for example to check a new installation or answer a support call. It is logged and every admin is notified. Starting a new one ends the current one.</p>
        <Field label="Company" wide>
          <select value={org} onChange={(e) => setOrg(e.target.value)} required>
            {clients.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
          </select>
        </Field>
        <Field label="For">
          <div className="chips">{[1, 4, 8].map((h) => <button type="button" key={h} className={hours === h ? "on" : ""} aria-pressed={hours === h} onClick={() => setHours(h)}>{h} h</button>)}</div>
        </Field>
        <Field label="Reason" wide hint="Shown in Activity and to other admins, e.g. 'Ticket 1042 — tracker not reporting'.">
          <input value={reason} onChange={(e) => setReason(e.target.value)} required minLength={5} maxLength={300} />
        </Field>
        {!clients.length && <div className="wide"><Notice kind="warn">There are no client companies yet.</Notice></div>}
        {err && <div className="error wide">{err}</div>}
      </form>
    </Drawer>
  );
}
